export default {
  bind (el, binding, vnode) {
    el.addEventListener('dragstart', (e) => {
      if (!vnode.context.$root.$store.getters.isAssetSelected(binding.value)) {
        vnode.context.$root.$store.dispatch('toggleAssetSelected', {
          path: binding.value
        })
      }
      e.dataTransfer.setData('assets', 'true')
    })
  }
}
